import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../coupons/Coupon.css';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from '../utils/hasPrivilege';
import { CSVLink } from 'react-csv';
import Modal from "react-modal";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Pie } from 'react-chartjs-2';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);
const Summer = () => {
  const { userData } = useUser();
  const token = localStorage.getItem('auth-token');
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState("");
  const today = new Date();
  const { selectedCenter, setSelectedCenter } = useUser();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);
  const [academies, setAcademies] = useState([]);
  const [startDate, setStartDate] = useState(tenDaysAgo.toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(today.toISOString().split('T')[0]);

  const [selectedAcademy, setSelectedAcademy] = useState('');
  const [selectedSport, setSelectedSport] = useState('');
  useEffect(() => {

    if (selectedCenter) {
      setSelectedAcademy(selectedCenter);
    } else if (userData?.userType === "ACADEMY") {
      if (userData.academyIds?.length > 0) {
        const validAcademyId = userData.academyIds?.find((academyId) =>
          apiData.some((item) => Number(item.academy_id) === Number(academyId))
        );

        if (validAcademyId) {
          setSelectedAcademy("allAcademies");
        } else {
          setSelectedAcademy("");
        }
      } else {
        setSelectedAcademy("");
      }
    } else {
      setSelectedAcademy("");
    }

    return () => {
      setSelectedAcademy("");
    };
  }, [userData, selectedCenter, apiData]);


  const headers = [
    { label: "Name", key: "user_name" },
    { label: "Mobile Number", key: "mobile_number" },
    { label: "Academy Name", key: "academy_name" },
    { label: "Sport Name", key: "sport_name" },
    { label: "Date", key: "created_at" },
    { label: "Status", key: "status" },
    { label: "Remarks", key: "remarks" },
  ];


    const fetchDropOffLeads = async () => {
      setLoading(true);
      setError(null);
  
      try {
        const response = await fetch(process.env.REACT_APP_API_PURCHASE, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
  
        if (data.success) {
          const fetchedData = data.data.dropOffLeads || [];
          const fetchedAcademies = data.data.academies || [];
  
          setApiData(fetchedData);
          setFilteredData(fetchedData);
          setAcademies(fetchedAcademies);
        } else {
          throw new Error('API response unsuccessful');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
    fetchDropOffLeads();
  }, []);
  

  useEffect(() => {
    let updatedData = apiData.filter((item) => {
      const itemCreatedAt = item.created_at ? new Date(item.created_at) : new Date();

      const matchesSearch = searchTerm
        ? Object.values(item).join(' ').toLowerCase().includes(searchTerm.toLowerCase())
        : true;
      const adjustedEndDate = endDate ? new Date(new Date(endDate).setHours(23, 59, 59, 999)) : null;

      const matchesStartDate = startDate ? itemCreatedAt >= new Date(startDate) : true;
      const matchesEndDate = adjustedEndDate ? itemCreatedAt <= adjustedEndDate : true;

      const matchesAcademy = selectedAcademy === "allAcademies"
        ? userData.academyIds.includes(Number(item.academy_id))
        : selectedAcademy
          ? Number(item.academy_id) === Number(selectedAcademy)
          : true;

      const matchesSport = selectedSport ? item.sport_name === selectedSport : true;

      return matchesSearch && matchesStartDate && matchesEndDate && matchesAcademy && matchesSport;
    });

    setFilteredData(updatedData);
    setCurrentPage(1);
  }, [searchTerm, startDate, endDate, selectedAcademy, selectedSport, apiData, userData.academyIds]);


  const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'descending' });
  const handleSort = (columnKey) => {
    let direction = 'ascending';

    if (sortConfig.key === columnKey && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    setSortConfig({ key: columnKey, direction });
  };

  const sortData = (data) => {
    const { key, direction } = sortConfig;

    if (!key) return data;

    const sorted = [...data].sort((a, b) => {
      if (key === 'created_at') {
        const aDate = new Date(a[key]);
        const bDate = new Date(b[key]);
        return direction === 'ascending' ? aDate - bDate : bDate - aDate;
      }

      const aValue = a[key];
      const bValue = b[key];

      if (aValue < bValue) return direction === 'ascending' ? -1 : 1;
      if (aValue > bValue) return direction === 'ascending' ? 1 : -1;
      return 0;
    });

    return sorted;
  };

  const sortedData = sortData(filteredData);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [remarks, setRemarks] = useState("");

  const openModal = (item) => {
    setSelectedItem(item);
    setRemarks(item.remarks || '');
    const normalizedStatus = item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase() : '';
    setStatus(normalizedStatus);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedItem(null);
    setRemarks("");
    setStatus("");
  };
  const handleSaveRemarks = async () => {
    if (remarks.trim() === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Remark cannot be empty!',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    if (status.trim() === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please select a status!',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }


    const upperCaseStatus = status.toUpperCase();
    const updatedItem = {
      ...selectedItem,
      remarks: remarks,
      status: upperCaseStatus
    };

    const payload = {
      status: upperCaseStatus,
      remarks: remarks,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_LEAD_UPDATE}/${selectedItem.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const responseBody = await response.json();

      if (response.ok && responseBody.success) {

        const data = responseBody.data || {};

        setApiData((prevData) =>
          prevData.map((item) =>
            item.id === selectedItem.id ? updatedItem : item
          )
        );

        setFilteredData((prevData) =>
          prevData.map((item) =>
            item.id === selectedItem.id ? updatedItem : item
          )
        );

        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Remark updated successfully!',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });

        closeModal();
      } else {
        throw new Error('Failed to update the item.');
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'There was an error while updating the remark.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };


  const filterChartData = (data) => {
    return {
      labels: data.filter(item => item.value !== 0).map(item => item.label),
      datasets: [
        {
          data: data.filter(item => item.value !== 0).map(item => item.value),
          backgroundColor: data.filter(item => item.value !== 0).map(item => item.color),
          hoverOffset: 4
        }
      ]
    };
  };

  const [pieData, setPieData] = useState({
    badminton: { Called: 0, Interested: 0, Lead: 0, Junk: 0, Converted: 0 },
    swimming: { Called: 0, Interested: 0, Lead: 0, Junk: 0, Converted: 0 }
  });

  useEffect(() => {

    const updatePieData = () => {
      const updatedPieData = {
        badminton: { Called: 0, Interested: 0, Lead: 0, Junk: 0, Converted: 0 },
        swimming: { Called: 0, Interested: 0, Lead: 0, Junk: 0, Converted: 0 },
      };

      filteredData.forEach((item) => {
        const status = item.status ? item.status.toLowerCase() : '';
        const sport = item.sport_name ? item.sport_name.toLowerCase() : '';


        if (sport === 'badminton') {
          if (status === 'called') updatedPieData.badminton.Called += 1;

          else if (status === 'interested') updatedPieData.badminton.Interested += 1;
          else if (status === 'lead') updatedPieData.badminton.Lead += 1;
          else if (status === 'converted') updatedPieData.badminton.Converted += 1;
          else if (status === 'junk') updatedPieData.badminton.Junk += 1;
        }


        if (sport === 'swimming') {
          if (status === 'called') updatedPieData.swimming.Called += 1;

          else if (status === 'interested') updatedPieData.swimming.Interested += 1;
          else if (status === 'lead') updatedPieData.swimming.Lead += 1;
          else if (status === 'converted') updatedPieData.swimming.Converted += 1;
          else if (status === 'junk') updatedPieData.swimming.Junk += 1;
        }
      });

      setPieData(updatedPieData);
    };

    updatePieData();
  }, [filteredData]);

  const badmintonChartData = filterChartData([
    { label: 'Called', value: pieData.badminton.Called, color: '#36A2EB' },
    { label: 'Interested', value: pieData.badminton.Interested, color: '#FFCE56' },
    { label: 'Lead', value: pieData.badminton.Lead, color: '#FF9F40' },
    { label: 'Converted', value: pieData.badminton.Converted, color: '#4BC0C0' },
    { label: 'Junk', value: pieData.badminton.Junk, color: '#E74C3C' },
  ]);


  const swimmingChartData = filterChartData([
    { label: 'Called', value: pieData.swimming.Called, color: '#36A2EB' },
    { label: 'Interested', value: pieData.swimming.Interested, color: '#FFCE56' },
    { label: 'Lead', value: pieData.swimming.Lead, color: '#FF9F40' },
    { label: 'Converted', value: pieData.swimming.Converted, color: '#4BC0C0' },
    { label: 'Junk', value: pieData.swimming.Junk, color: '#E74C3C' },
  ]);

  const totalEntries = filteredData.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;
  const academyOptions = userData.userType === "ACADEMY"
    ? [
      { value: 'allAcademies', label: 'All Academies' },
      ...userData.academyIds
        .map(id => {
          const academy = academies.find(a => a.id === id);
          return academy ? { value: String(academy.id), label: academy.name } : null;
        })
        .filter(Boolean)
    ]
    : [
      { value: '', label: 'All Academies' },
      ...academies.map(a => ({ value: String(a.id), label: a.name }))
    ];

  const sportOptions = [
    { value: '', label: 'All Sports' },
    ...[...new Set(apiData.map(item => item.sport_name))].map(sport => ({
      value: sport,
      label: sport
    }))
  ];

  return (
    <div className="enrollment-container">
      {/* Filters Section */}
      <div className="sales-filters-login" style={{overflowY:'visible'}}>

        <div className="floating-select">
          <Select
            options={academyOptions}
            value={academyOptions.find(option => String(option.value) === String(selectedAcademy))}
            onChange={(option) => setSelectedAcademy(option?.value ?? '')}
            classNamePrefix="react-select"
            placeholder="Select Academy"
            className={`sales-filter-court-booking ${selectedAcademy ? "has-value" : ""}`}
            menuPortalTarget={document.body} 
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
            }}
          />

          {selectedAcademy && <label htmlFor="academy">Academy</label>}
        </div>



        <div className="floating-select">
        <Select
            options={sportOptions}
            value={sportOptions.find(option => option.value === selectedSport)}
            onChange={(selectedOption) => setSelectedSport(selectedOption?.value || '')}
            classNamePrefix="react-select"
            className={`sales-filter-court-booking ${selectedSport ? "has-value" : ""}`}
            placeholder="Select Sport"
            menuPortalTarget={document.body} 
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
            }}
          />
          {selectedSport && <label htmlFor="sport">Sport</label>}
        </div>
        <div className="floating-select">
          <input
            type="date"
            placeholder="Trial Start Date"
            name="trialStartDate"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
            className={`sales-filter-court-booking ${startDate ? "has-value" : ""}`}
          />
          {startDate && <label htmlFor="trialStartDate">Start Date</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            placeholder="Trial End Date"
            name="trialEndDate"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
            className={`sales-filter-court-booking ${endDate ? "has-value" : ""}`}
          />
          {endDate && <label htmlFor="trialEndDate">End Date</label>}
        </div>

      </div>
      <div className="unique-charts-container">
        {(!selectedSport || selectedSport.toLowerCase() === 'badminton') &&
          (pieData.badminton.Called > 0 || pieData.badminton.Interested > 0 || pieData.badminton.Lead > 0 || pieData.badminton.Junk > 0 || pieData.badminton.Converted > 0) && (
            <div className="unique-chart-dropoffs">
              <h3 className="pie-title" style={{textAlign:'center'}}>Badminton Status</h3>
              <Pie data={badmintonChartData} />
            </div>
          )}

        {(!selectedSport || selectedSport.toLowerCase() === 'swimming') &&
          (pieData.swimming.Called > 0 || pieData.swimming.Interested > 0 || pieData.swimming.Lead > 0 || pieData.swimming.Junk > 0 || pieData.swimming.Converted > 0) && (
            <div className="unique-chart-dropoffs">
              <h3 className="pie-title" style={{textAlign:'center'}}>Swimming Status </h3>
              <Pie data={swimmingChartData} />
            </div>
          )}
      </div>

      <div className="search-create-container">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <CSVLink
          data={filteredData}
          headers={headers}
          filename="SummerDropoffs.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchDropOffLeads}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>
      </div>
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredData.length === 0 && (
        <div className="error-message">No data available</div>
      )}
      {/* Coupon Table */}
      
      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
              {hasPrivilege(userData, 'MARKETING', 'DROPOFFS_OF_SUMMER_CAMP_MODIFY') && (<th>Action</th>)}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((item) => (
              <tr key={item.id}>
                <td>{item.user_name}</td>
                <td>{item.mobile_number}</td>
                <td>{item.academy_name}</td>
                <td>{item.sport_name}</td>
                <td>{new Date(item.created_at).toISOString().slice(0, 16).replace("T", " ")}</td>
                <td>{item.status || 'No status'}</td>

                <td>
                  {item.remarks ? item.remarks : '-'}
                </td>
                {hasPrivilege(userData, 'MARKETING', 'DROPOFFS_OF_SUMMER_CAMP_MODIFY') && (
                  <td className="border p-2 text-center relative">
                    <div className="inline-block">
                      <button
                        onClick={() => openModal(item)}
                        className="resolve-button"
                      >
                        {item.remarks ? 'Update Remark' : 'Add Remark'}
                      </button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="Modal__Content rounded-lg bg-white p-6 shadow-lg transition-all transform scale-95 hover:scale-100 duration-300"
        overlayClassName="Modal__Overlay fixed inset-0 bg-black bg-opacity-50"
      >
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">
          {remarks ? "Update Remark" : "Add Remark"}
        </h2>

        <div className="mb-4">
          <textarea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
            placeholder="Enter remarks..."
            rows="4"
          />
        </div>

        <div className="mb-6">
          <label className="block font-semibold text-gray-700 mb-2">Status</label>
          <div className="flex space-x-4">
            <label className="flex items-center">
              <input
                type="radio"
                name="status"
                value="Called"
                checked={status === 'Called'}
                onChange={(e) => setStatus(e.target.value)}
                className="mr-2"
              />
              Called
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="status"
                value="Interested"
                checked={status === 'Interested'}
                onChange={(e) => setStatus(e.target.value)}
                className="mr-2"
              />
              Interested
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="status"
                value="Junk"
                checked={status === 'Junk'}
                onChange={(e) => setStatus(e.target.value)}
                className="mr-2"
              />
              Junk
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="status"
                value="Converted"
                checked={status === 'Converted'}
                onChange={(e) => setStatus(e.target.value)}
                className="mr-2"
              />
              Converted
            </label>
          </div>
        </div>

        <div className="mt-6 flex justify-end space-x-4">
          <button
            onClick={closeModal}
            className="cancel-button"
            style={{
              background:'red'
            }}

          >
            Cancel
          </button>

          <button
            onClick={handleSaveRemarks}
            className="save-button"
          >
            {remarks ? "Update" : "Save"}
          </button>
        </div>
      </Modal>
      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Summer;